<script setup>
    const props = defineProps({
        palette: {
            type: String,
            default: 'gray'
        }
    })
</script>

<template>
    <span :class="[
        'font-semibold text-sm pb-2 inline-block',
        {
            'text-lifeworx-blue-900': props.palette === 'dark-blue',
            'text-stone-500': props.palette === 'gray'
        }
    ]">
        <slot></slot>
    </span>
</template>
